import uiRouter from 'angular-ui-router';
import RavenModule from './error-reporters/raven';
import StateServiceModule from './state/state';
import VerificationServiceModule from './message/verification-message';
import UyaTextHelperServiceModule from './uya-text-helper/uya-text-helper';

export default angular.module('app.services', [
  uiRouter,
  RavenModule.name,
  StateServiceModule.name,
  VerificationServiceModule.name,
  UyaTextHelperServiceModule.name,
]);
